export const mockBundleResults = [
  {
    "name": "Bundle Silver",
    "id": 1,
    "is_cancellation_protection_auto_add": false,
    "products": [
      {
        "product_code": "lounges",
        "inventory_provider": "internal",
        "inventory_id": "7719-109521",
        "details": {
          "baggage_type": null,
          "visiting_duration": null,
          "visiting_duration_message": null,
          "entry_date": "2024-12-03T12:00:00",
          "exit_date": "2024-12-03T13:30:00",
          "direction": null,
          "airline_name": null
        },
        "inventory_item": {
          "name": "Lounge Access",
          "description": "Lounge Access",
          "entrance_info": "Lounge Access",
          "logo": {
            "src": "https://d1yzlzxxfh5mr5.cloudfront.net/images/lounge_logo_24ce7fd6-4c18-4326-87c1-bdd938bbfd29.svg",
            "description": "Lounge Access"
          },
          "product_logo": {
            "src": null
          },
          "images": [
            {
              "src": "https://d1yzlzxxfh5mr5.cloudfront.net/images/lounge_logo_24ce7fd6-4c18-4326-87c1-bdd938bbfd29.svg",
              "description": "Lounge Access"
            }
          ],
          "product_option": {
            "code": "lounge_access",
            "name": "Lounge Access"
          },
          "upgrade": null,
          "capacity": {
            "left": 10,
            "message_threshold": null
          },
          "additional_fields": {
            "inbound_flight_number": {
              "is_required": true,
              "is_shown": true
            },
            "outbound_flight_number": {
              "is_required": true,
              "is_shown": true
            }
          },
          "baggage_type": null,
          "visiting_duration": null,
          "visiting_duration_message": null,
          "entry_date": "2024-12-03T12:00:00",
          "exit_date": "2024-12-03T13:30:00",
          "pii_questions": {
            "order_management": null,
            "payment": null
          },
          "direction": null,
          "airline_name": null
        },
        "inventory_options": [
          {
            "fees": [],
            "meta": {
              "product_option_code": "lounge_regular",
              "direction": null
            },
            "cancellation_policies": [
              {
                "title": "Cancellation Policy",
                "message": "Free cancellation up to 20 days before arrival. Cancellable with a fee of $1 between 20 days and 10 days before arrival. Cancellable with a fee of $2 between 10 days and 1 day before arrival. No cancellation between 1 day and 0 day before arrival."
              }
            ],
            "taxes": [],
            "amendment_policies": [
              {
                "title": "Amendment Policy",
                "message": "Free amendment up to 7 days before arrival. Amendable with a fee of 10% between 7 days and 5 days before arrival. Amendable with a fee of $5 between 5 days and 1 day before arrival. Non-amendable between 1 day and 0 day before arrival."
              }
            ],
            "details": {
              "duration": 90,
              "groups": {
                "senior": {
                  "is_selected": false
                },
                "adult": {
                  "is_selected": true,
                  "totals": {
                    "single_total": 5.2,
                    "subtotal": 5.2,
                    "quantity": 1
                  }
                },
                "infant": {
                  "is_selected": false,
                  "exclude_from_capacity": false
                },
                "child": {
                  "is_selected": false
                }
              },
              "cancellation_protection": {
                "cancellation_policies": [
                  {
                    "title": "Cancellation Policy",
                    "message": "Free cancellation up to 3 hours before arrival."
                  }
                ],
                "taxes": [],
                "totals": {
                  "taxes": 0,
                  "total": 4.99,
                  "fees": 0,
                  "channel_based": {
                    "total": 4.99
                  },
                  "subtotal": 4.99
                },
                "message": "For just $4.99 you can cancel your booking online up to 3 hours before the day of travel and avoid a cancellation charge.",
                "is_available": true
              },
              "is_parent": true
            },
            "sub_options": [
              {
                "fees": [],
                "internal": {
                  "tax_rules": [],
                  "expires_at": "2024-11-07T14:06:38+00:00",
                  "booking_request": {
                    "channel_commission_override_type": null,
                    "quantity": 1,
                    "provider_partner_name": null,
                    "check_in_type": "outbound",
                    "partner_id": 69,
                    "product_type": "lounges",
                    "provider": "internal",
                    "channel_commission_override_value": null,
                    "product_id": 109521,
                    "product_commission": null,
                    "provider_data": [],
                    "provider_id": null,
                    "provider_commission_override_value": null,
                    "channel_id": 22
                  },
                  "fee_rules": []
                },
                "meta": {
                  "product_option_code": "lounge_regular",
                  "direction": null
                },
                "taxes": [],
                "details": {
                  "name": "adult",
                  "duration": 90,
                  "name_formatted": "Adult"
                },
                "id": 109522,
                "totals": {
                  "fees": 0,
                  "total": 5.2,
                  "quantity": 1,
                  "subtotal": 5.2,
                  "discount": 0,
                  "taxes": 0,
                  "currency": "USD",
                  "exchange": null,
                  "channel_based": {
                    "total": 5.2,
                    "total_discounted": 5.2
                  }
                },
                "is_available": true
              }
            ],
            "id": 109521,
            "totals": {
              "fees": 0,
              "total": 5.2,
              "quantity": 1,
              "subtotal": 5.2,
              "discount": 0,
              "taxes": 0,
              "currency": "USD",
              "exchange": null,
              "channel_based": {
                "total": 5.2,
                "total_discounted": 5.2
              }
            },
            "is_available": true
          }
        ]
      }
    ],
    "totals": {
      "fees": 0.83,
      "total": 8,
      "quantity": 1,
      "subtotal": 5.79,
      "discount": 0,
      "bundle_saving": 20,
      "taxes": 1.39,
      "currency": "USD",
      "exchange": null,
      "channel_based": {
        "total": 6.62,
        "total_discounted": 6.62
      }
    }
  },
  {
    "name": "Bundle Gold",
    "id": 2,
    "is_cancellation_protection_auto_add": true,
    "products": [
      {
        "product_code": "lounges",
        "inventory_provider": "internal",
        "inventory_id": "7719-109521",
        "details": {
          "baggage_type": null,
          "visiting_duration": null,
          "visiting_duration_message": null,
          "entry_date": "2024-12-03T12:00:00",
          "exit_date": "2024-12-03T13:30:00",
          "direction": null,
          "airline_name": null
        },
        "inventory_item": {
          "name": "Lounge Access",
          "description": "Lounge Access",
          "entrance_info": "Lounge Access",
          "logo": {
            "src": "https://d1yzlzxxfh5mr5.cloudfront.net/images/lounge_logo_24ce7fd6-4c18-4326-87c1-bdd938bbfd29.svg",
            "description": "Lounge Access"
          },
          "product_logo": {
            "src": null
          },
          "images": [
            {
              "src": "https://d1yzlzxxfh5mr5.cloudfront.net/images/lounge_logo_24ce7fd6-4c18-4326-87c1-bdd938bbfd29.svg",
              "description": "Lounge Access"
            }
          ],
          "product_option": {
            "code": "lounge_access",
            "name": "Lounge Access"
          },
          "upgrade": null,
          "capacity": {
            "left": 10,
            "message_threshold": null
          },
          "additional_fields": {
            "inbound_flight_number": {
              "is_required": true,
              "is_shown": true
            },
            "outbound_flight_number": {
              "is_required": true,
              "is_shown": true
            }
          },
          "baggage_type": null,
          "visiting_duration": null,
          "visiting_duration_message": null,
          "entry_date": "2024-12-03T12:00:00",
          "exit_date": "2024-12-03T13:30:00",
          "pii_questions": {
            "order_management": null,
            "payment": null
          },
          "direction": null,
          "airline_name": null
        },
        "inventory_options": [
          {
            "fees": [],
            "meta": {
              "product_option_code": "lounge_regular",
              "direction": null
            },
            "cancellation_policies": [
              {
                "title": "Cancellation Policy",
                "message": "Free cancellation up to 20 days before arrival. Cancellable with a fee of $1 between 20 days and 10 days before arrival. Cancellable with a fee of $2 between 10 days and 1 day before arrival. No cancellation between 1 day and 0 day before arrival."
              }
            ],
            "taxes": [],
            "amendment_policies": [
              {
                "title": "Amendment Policy",
                "message": "Free amendment up to 7 days before arrival. Amendable with a fee of 10% between 7 days and 5 days before arrival. Amendable with a fee of $5 between 5 days and 1 day before arrival. Non-amendable between 1 day and 0 day before arrival."
              }
            ],
            "details": {
              "duration": 90,
              "groups": {
                "senior": {
                  "is_selected": false
                },
                "adult": {
                  "is_selected": true,
                  "totals": {
                    "single_total": 5.2,
                    "subtotal": 5.2,
                    "quantity": 1
                  }
                },
                "infant": {
                  "is_selected": false,
                  "exclude_from_capacity": false
                },
                "child": {
                  "is_selected": false
                }
              },
              "cancellation_protection": {
                "cancellation_policies": [
                  {
                    "title": "Cancellation Policy",
                    "message": "Free cancellation up to 3 hours before arrival."
                  }
                ],
                "taxes": [],
                "totals": {
                  "taxes": 0,
                  "total": 4.99,
                  "fees": 0,
                  "channel_based": {
                    "total": 4.99
                  },
                  "subtotal": 4.99
                },
                "message": "For just $4.99 you can cancel your booking online up to 3 hours before the day of travel and avoid a cancellation charge.",
                "is_available": true
              },
              "is_parent": true
            },
            "sub_options": [
              {
                "fees": [],
                "internal": {
                  "tax_rules": [],
                  "expires_at": "2024-11-07T14:06:38+00:00",
                  "booking_request": {
                    "channel_commission_override_type": null,
                    "quantity": 1,
                    "provider_partner_name": null,
                    "check_in_type": "outbound",
                    "partner_id": 69,
                    "product_type": "lounges",
                    "provider": "internal",
                    "channel_commission_override_value": null,
                    "product_id": 109521,
                    "product_commission": null,
                    "provider_data": [],
                    "provider_id": null,
                    "provider_commission_override_value": null,
                    "channel_id": 22
                  },
                  "fee_rules": []
                },
                "meta": {
                  "product_option_code": "lounge_regular",
                  "direction": null
                },
                "taxes": [],
                "details": {
                  "name": "adult",
                  "duration": 90,
                  "name_formatted": "Adult"
                },
                "id": 109522,
                "totals": {
                  "fees": 0,
                  "total": 5.2,
                  "quantity": 1,
                  "subtotal": 5.2,
                  "discount": 0,
                  "taxes": 0,
                  "currency": "USD",
                  "exchange": null,
                  "channel_based": {
                    "total": 5.2,
                    "total_discounted": 5.2
                  }
                },
                "is_available": true
              }
            ],
            "id": 109521,
            "totals": {
              "fees": 0,
              "total": 5.2,
              "quantity": 1,
              "subtotal": 5.2,
              "discount": 0,
              "taxes": 0,
              "currency": "USD",
              "exchange": null,
              "channel_based": {
                "total": 5.2,
                "total_discounted": 5.2
              }
            },
            "is_available": true
          }
        ]
      },
      {
        "search_product_result_id": "2fe89d5c-5ca5-4f17-9029-faff342f0701",
        "product_code": "fasttrack",
        "inventory_provider": "internal",
        "inventory_id": "7763-89108",
        "inventory_item": {
          "upgrade": null,
          "description": "<p>KY_test1</p>",
          "additional_fields": {
            "zipcode": {
              "is_required": false,
              "is_show": false
            },
            "inbound_flight_number": {
              "is_required": false,
              "is_show": false
            },
            "phone_number": {
              "is_required": false,
              "is_show": false
            },
            "plate_number": {
              "is_required": false,
              "is_show": false
            },
            "outbound_flight_number": {
              "is_required": false,
              "is_show": false
            }
          },
          "product_option": {
            "name": "Flying In",
            "code": "flying_in"
          },
          "entrance_info": "<p>Post booking<br /><a href=\\'https://test.ecommerce.partner-747.test.web.cavu-tech.com/\\'>Link</a></p>\n<p>привіт</p>\n<p>こんにちは</p>\n<p>Demo</p>\n<p>&nbsp;</p>",
          "capacity": {
            "left": 100,
            "message_threshold": null
          },
          "entry_date": "2024-12-03T11:45:00",
          "features": [],
          "name": "KY_test1",
          "logo": {
            "src": "https://d1yzlzxxfh5mr5.cloudfront.net/images/fasttrack_logo_0879e450-d12d-42ff-bc62-6373863b9f2e.svg",
            "description": "test updated"
          },
          "exit_date": "2024-12-03T12:00:00",
          "pii_questions": {
            "order_management": null,
            "payment": null
          },
          "is_featured": false,
          "direction": "inbound"
        },
        "details": {
          "exit_date": "2024-12-03T12:00:00",
          "entry_date": "2024-12-03T11:45:00",
          "direction": "inbound"
        },
        "inventory_options": [
          {
            "fees": [
              {
                "name": "Airport access fee",
                "amount": 2.42,
                "id": 36645
              },
              {
                "name": "Port access fee",
                "amount": 1.82,
                "id": 36646
              }
            ],
            "meta": {
              "product_option_code": "flying_in",
              "direction": "inbound"
            },
            "cancellation_policies": [
              {
                "title": "Cancellation Policy",
                "message": "Free cancellation up to 3 days before arrival. Cancellable with a fee of £1 between 3 days and 2 days before arrival. Non refundable between 2 days and 1 day before arrival. No cancellation between 1 day and 0 day before arrival."
              }
            ],
            "taxes": [
              {
                "name": "Sales Tax",
                "amount": 2,
                "id": 63970
              },
              {
                "name": "VAT (Value Added Tax)",
                "amount": 2.2,
                "id": 63969
              }
            ],
            "amendment_policies": [
              {
                "title": "Amendment Policy",
                "message": "Non-amendable up to 0 day before arrival."
              }
            ],
            "details": {
              "duration": 15,
              "groups": {
                "senior": {
                  "age": {
                    "min": 2
                  },
                  "is_selected": true
                },
                "adult": {
                  "age": {
                    "min": 4
                  },
                  "is_selected": true,
                  "totals": {
                    "single_total": 20,
                    "subtotal": 20,
                    "quantity": 1
                  }
                },
                "infant": {
                  "age": {
                    "max": 1,
                    "min": 0
                  },
                  "is_selected": true,
                  "exclude_from_capacity": false
                },
                "child": {
                  "age": {
                    "max": 3,
                    "min": null
                  },
                  "is_selected": true
                }
              },
              "cancellation_protection": {
                "is_available": false
              },
              "is_parent": true
            },
            "sub_options": [
              {
                "fees": [
                  {
                    "name": "Port access fee",
                    "amount": 1.82,
                    "id": 36646
                  },
                  {
                    "name": "Airport access fee",
                    "amount": 2.42,
                    "id": 36645
                  }
                ],
                "internal": {
                  "tax_rules": [
                    {
                      "name": "VAT (Value Added Tax)",
                      "is_inclusive": false,
                      "amount": 10,
                      "is_calculate_in_post": true,
                      "id": 63969
                    },
                    {
                      "name": "Sales Tax",
                      "is_inclusive": true,
                      "amount": 10,
                      "is_calculate_in_post": true,
                      "id": 63970
                    }
                  ],
                  "expires_at": "2024-11-07T15:24:17+00:00",
                  "booking_request": [],
                  "fee_rules": [
                    {
                      "amount_type": "percentage",
                      "amount": 10,
                      "is_calculate_in_post": true,
                      "apply": "post",
                      "name": "Airport access fee",
                      "id": 36645,
                      "frequency": "fixed"
                    },
                    {
                      "amount_type": "percentage",
                      "amount": 10,
                      "is_calculate_in_post": true,
                      "apply": "pre",
                      "name": "Port access fee",
                      "id": 36646,
                      "frequency": "fixed"
                    }
                  ]
                },
                "meta": {
                  "product_option_code": "flying_in",
                  "direction": "inbound"
                },
                "taxes": [
                  {
                    "name": "Sales Tax",
                    "amount": 2,
                    "id": 63970
                  },
                  {
                    "name": "VAT (Value Added Tax)",
                    "amount": 2.2,
                    "id": 63969
                  }
                ],
                "details": {
                  "name": "adult",
                  "duration": 15,
                  "name_formatted": "Adult"
                },
                "id": 89109,
                "totals": {
                  "fees": 4.24,
                  "total": 26.62,
                  "quantity": 1,
                  "subtotal": 18.18,
                  "discount": 0,
                  "taxes": 4.2,
                  "currency": "GBP",
                  "exchange": null,
                  "channel_based": {
                    "total": 18.18,
                    "total_discounted": 18.18
                  }
                },
                "is_available": true
              }
            ],
            "id": 89108,
            "totals": {
              "fees": 4.24,
              "total": 26.62,
              "quantity": 1,
              "subtotal": 18.18,
              "discount": 0,
              "taxes": 4.2,
              "currency": "GBP",
              "exchange": null,
              "channel_based": {
                "total": 18.18,
                "total_discounted": 18.18
              }
            },
            "is_available": true
          }
        ]
      }
    ],
    "totals": {
      "fees": 0.83,
      "total": 130,
      "quantity": 1,
      "subtotal": 120,
      "discount": 0,
      "bundle_saving": 20,
      "taxes": 1.39,
      "currency": "USD",
      "exchange": null,
      "channel_based": {
        "total": 6.62,
        "total_discounted": 6.62
      }
    }
  }
]
